// @ts-check
import React from 'react';

import * as SharedRuleset from 'shared/components/Providers/Ruleset';

const Edit = () => (
  <SharedRuleset.Edit
    apiPrefix={`/agent_portal/api/current_provider_employment/referral_ruleset`}
  />
);

export { Edit };
